<fieldset class="field-group" *ngIf="documentChips?.length">
  <legend>Related</legend>
  <document-chips [documentChips]="documentChips"></document-chips>
</fieldset>
